import { type FanShopProductVariant } from '@capsicum/common';
import { ChipList, type ChipListItem } from '@capsicum/common-web';
import { type ReactNode, type RefObject } from 'react';
import styled from 'styled-components';

import { LoadingIndicator } from '../loading-indicator/LoadingIndicator';
import { ProductCard } from '../product-card/ProductCard';
import { ProductListEmptyComponent } from '../product-list-empty-component/ProductListEmptyComponent';

type ProductsLobbySectionProps = {
	chipCategories: Array<ChipListItem>;
	chipsSelected: (value: Array<string>) => void;
	isFetched: boolean;
	isFetchingNextPage: boolean;
	listEndRef: RefObject<HTMLDivElement>;
	loadingProducts: boolean;
	mockTutorialCard?: ReactNode;
	onProductClick: (productId?: string) => void;
	products: Array<FanShopProductVariant>;
};

export const ProductsLobbySection = ({
	chipCategories,
	chipsSelected,
	isFetched,
	isFetchingNextPage,
	listEndRef,
	loadingProducts,
	mockTutorialCard,
	onProductClick,
	products
}: ProductsLobbySectionProps) => {
	return (
		<>
			{chipCategories.length > 1 && (
				<ChipList
					hasWrapper={false}
					items={chipCategories}
					itemsSelected={chipsSelected}
					selectionType="multiple"
				/>
			)}
			{/* // TODO: Test if ProductContainer with skeleton is stills need it */}
			<S.ProductContainer>
				{loadingProducts && <LoadingIndicator />}
				<S.ProductsWrapper $chipsVisible={chipCategories.length > 1}>
					{!!mockTutorialCard && mockTutorialCard}
					{products.length > 0 &&
						products.map(product => (
							<ProductCard
								key={`${product?.id}-${product?.label}`}
								testID={`product-lobby-productVariant-${product.id}`}
								variant={product}
								onClick={() => onProductClick(product.id)}
							/>
						))}
					<div ref={listEndRef}></div>
				</S.ProductsWrapper>
				{isFetchingNextPage && <LoadingIndicator />}
				{isFetched && !products.length && <ProductListEmptyComponent />}
			</S.ProductContainer>
		</>
	);
};

namespace S {
	export const ProductsWrapper = styled.div<{ $chipsVisible: boolean }>`
		display: flex;
		flex-wrap: wrap;
		row-gap: ${({ theme }) => theme.spacings.small};
		column-gap: ${({ theme }) => theme.spacings.small};
		width: 100%;
		margin-top: ${({ $chipsVisible, theme }) => ($chipsVisible ? theme.spacings.xlarge : 0)};
		margin-bottom: ${({ theme }) => theme.spacings.xlarge};
		justify-content: flex-start;
		${({ theme }) => theme.breakpoints.queries.only.largeDesktop} {
			justify-content: flex-start;
			column-gap: ${({ theme }) => theme.spacings.large};
		}
		${({ theme }) => theme.breakpoints.queries.below.mobile} {
			display: grid;
			grid-template-columns: repeat(auto-fit, minmax(calc(50% - 32px), 1fr));
			justify-items: center;
			column-gap: ${({ theme }) => theme.spacings.xsmall};
		}
	`;

	// TODO: Test if with skeleton is stills need it
	export const ProductContainer = styled.div`
		min-height: 100vh;
	`;
}
